import { render, staticRenderFns } from "./DistrictInfo.vue?vue&type=template&id=2ff903f2&scoped=true"
import script from "./DistrictInfo.vue?vue&type=script&lang=js"
export * from "./DistrictInfo.vue?vue&type=script&lang=js"
import style0 from "./DistrictInfo.vue?vue&type=style&index=0&id=2ff903f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff903f2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VImg,VLayout,VRow,VTextField})
